import { render, staticRenderFns } from "./ClassroomStreamSidebar.vue?vue&type=template&id=bf27ddfa&scoped=true&"
import script from "./ClassroomStreamSidebar.vue?vue&type=script&lang=js&"
export * from "./ClassroomStreamSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf27ddfa",
  null
  
)

export default component.exports